module.exports = __webpack_public_path__ + "img/4-7years.1b5c7b8b.svg";